import React from 'react'
import "./Footer.css";
import github from "../../assets/github.png"
import instagram from "../../assets/instagram.png"
import linkedin from "../../assets/linkedin.png"
import logo from "../../assets/logo.png"

const Footer = () => {
    return (
        <div className="footer-container">
            <hr />
            <div className="footer">
                <div className="social-icon">
                    <img src={github} alt="" />
                    <img src={instagram} alt="" />
                    <img src={linkedin} alt="" />
                </div>
                <div className="footer-logo">
                    <img src={logo} alt="" />
                </div>
            </div>
                <div className="blur blur1"></div>
                <div className="blur blur2"></div>
        </div>
    )
}

export default Footer